module.exports = __webpack_public_path__ + "media/application/images/2018/facebook-blue@2x-f7f6582c67ca7e40fc47a856e7b27c47.png";